<template>
  <list-table
    url="getayandebestankar"
    title="گزارش موجودی بانک آینده"
    :fields="fields"
    :params="params"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
export default {
  name: "getayandebestankar",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      ayandeBestankar: [],
      fields: [
        {
          key: "name",
          label: "نام مالک حساب",
        },
        {
          key: "amount",
          label: "مبلغ",
          formatter(value, key, item) {
            return Number(amount).toLocaleString();
          },
        },
      ],
      params: [],
    };
  },
  mounted() {
    // httpHelper.getData("getayandebestankar").then((res) => {
    //   console.log(res);
    //   this.ayandeBestankar = re
    // });
  },
};
</script>